
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_dm8gx_2t353_103",
  "has-items": "awsui_has-items_dm8gx_2t353_137",
  "no-padding": "awsui_no-padding_dm8gx_2t353_137",
  "dismiss-button": "awsui_dismiss-button_dm8gx_2t353_141",
  "token": "awsui_token_dm8gx_2t353_183",
  "token-box": "awsui_token-box_dm8gx_2t353_190",
  "token-box-error": "awsui_token-box-error_dm8gx_2t353_209",
  "token-box-disabled": "awsui_token-box-disabled_dm8gx_2t353_220"
};
  